import React, { useCallback, useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";
import ProfileDisplay from "./../../Components/ProfileDisplay";

import "./style.css";

import FormModal from "../../Components/FormModal";
import Header from "../../Components/Header";
import useSelect from "../../Hooks/useSelect";
import useToggle from "../../Hooks/useToggle";
import { useUploadImageMutation } from "../../Redux/Apis/General";
import { useUpdateGuidelineMutation } from "../../Redux/Apis/Guidelines";
import { useCreateServiceMutation, useGetServicesQuery, useUpdateServiceMutation } from "../../Redux/Apis/Services";
import { dateFormatter } from "../../Utils";
import useSearch from "../../Hooks/useSearch";
import usePagination from "../../Hooks/usePagination";
import CustomModal from "../../Components/CustomModal";

const sortValues = [
    {
        text: "Name",
        value: "fullName",
    },
    {
        text: "Email",
        value: "email",
    }
];

const perPageValues = [
    {
        text: "8",
        value: 8,
    },
    {
        text: "15",
        value: 15,
    },
    {
        text: "30",
        value: 30,
    }
];

const maleHeaders = [
    {
        key: "id",
        title: "S.No",
    },
    {
        key: "title",
        title: "Service Name",
    },
    {
        key: "subtitle",
        title: "Subtitle",
    },
    {
        key: "createdAt",
        title: "Created Date",
    },
    {
        key: "actions",
        title: "",
    },
];

const Services = () => {

    const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
    const [selectedData, setSelectedData] = useState();

    const [formOpen, setFormOpen, toggleForm] = useToggle()
    const [isEdit, setIsEdit, toggleEdit] = useToggle()
    const [isFilterOpen, setIsFilterOpen, toggleFilter] = useToggle()

    const [sortBy, setSortBy] = useState(sortValues[0].value);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");

    const [search, debouncedSearch, onSearch] = useSearch()
    const { page, perPage, onNext, onPrevious } = usePagination()
    const { data, isLoading, refetch } = useGetServicesQuery({
        page,
        rowsPerPage: perPage,
        search: debouncedSearch,
        sortBy,
        from,
        to
    });
    const [updateGuideline, { data: updatedService, isSuccess: isUpdated, isLoading: isUpdating }] = useUpdateServiceMutation();
    const [submitService, { isSuccess }] = useCreateServiceMutation()
    // const [deleteGuideline, { data: deletedData, isSuccess: isDeleted, isLoading: isDeleting }] = useDeleteGuidelineMutation()
    const [upload] = useUploadImageMutation()

    const [confirmed, setConfirmed, toggleConfirmed] = useToggle()
    const { isAllSelected, totalSelected, onSelectAll, onSelectRow, isExists } = useSelect(data?.data)

    useEffect(() => {
        if (isSuccess) {
            toggleForm()
            refetch()
        }
    }, [isSuccess])

    useEffect(() => {
        if (isUpdated) {

            if (selectedData?.active !== updatedService?.data?.active) {
                toggleConfirmed()
            } else {
                setFormOpen(false)
                setIsEdit(false)
            }

            refetch()
            setSelectedData()
        }
    }, [isUpdated])

    // useEffect(() => {
    //     if (isDeleted) {
    //         refetch()
    //         setSelectedData()
    //         setShowModal(false)
    //         setShowModal2(true)
    //     }
    // }, [isDeleted])

    useEffect(() => {
        document.title = 'The Turn At | Services';
    }, []);

    const onSubmit = useCallback(async (data) => {
        if (isEdit) {
            updateGuideline({ ...data, _id: selectedData?._id })
        } else {

            let payload = {
                ...data
            }

            if (data?.image) {

                let formdata = new FormData()
                formdata.append("image", data?.image)

                await upload(formdata).then(res => {
                    payload = {
                        ...payload,
                        icon: res?.data?.data?.path
                    }
                })

            }

            submitService(payload)
        }
    }, [isEdit])

    // const onDelete = useCallback(() => {
    //     deleteGuideline(selectedData?._id)
    // }, [selectedData])

    const onToggle = useCallback(() => {
        if (isEdit) {
            toggleEdit()
            setSelectedData()
        }
        toggleForm()
    }, [isEdit, selectedData, formOpen])

    const onConfirm = () => {
        updateGuideline({ _id: selectedData?._id, active: !selectedData?.active })
    }

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="dashCard">
                                <Header
                                    title="Services"
                                    // buttons={[{ label: "Add Services", onClick: toggleForm, variant: "primaryButton" }]}
                                    length={totalSelected}
                                    search={search}
                                    onSearch={onSearch}
                                    nofilters
                                />
                                <div className="row mb-3">
                                    {
                                        isLoading ? <Loader /> :
                                            <div className="col-12">
                                                <CustomTable
                                                    headers={maleHeaders}
                                                    isFilterOpen={isFilterOpen}
                                                    dateFilter={false}
                                                    filterSort={false}
                                                    perPage={true}
                                                    filterSortValues={sortValues}
                                                    perPageValues={perPageValues}
                                                    filterSortValue={sortBy}
                                                    setFilterSortValue={setSortBy}
                                                    filterFrom={from}
                                                    setFilterFrom={setFrom}
                                                    filterTo={to}
                                                    setFilterTo={setTo}
                                                    itemsPerPage={itemsPerPage}
                                                    setItemsPerPage={setItemsPerPage}
                                                    length={data?.data?.length}
                                                    isAllSelected={isAllSelected}
                                                    onSelectAll={onSelectAll}
                                                    page={page}
                                                    rowsPerPage={perPage}
                                                    onNext={onNext}
                                                    onPrevious={onPrevious}
                                                    total={data?.total}
                                                >
                                                    <tbody>
                                                        {data?.data?.map((item, index) => (
                                                            <tr key={item._id}>
                                                                {/* <td><input type="checkbox" value={item._id} checked={isExists(item._id)} onClick={() => onSelectRow(item?._id)} /></td> */}
                                                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                                                <td className="text-capitalize">
                                                                    <ProfileDisplay
                                                                        name={item?.title}
                                                                        image={item?.icon}
                                                                        className="no-round"
                                                                    />
                                                                </td>
                                                                <td>{item.subtitle}</td>
                                                                <td>{dateFormatter(item?.createdAt)}</td>
                                                                <td className="d-flex justify-content-center align-items-center">
                                                                    <CustomButton variant="primaryButton" text="Edit" className="mx-1" onClick={() => { setSelectedData(item), toggleEdit(), toggleForm() }} />
                                                                    <CustomButton variant={item?.active ? "warningButton" : "dangerButton"} text={item?.active ? "Blacklist" : "Suspended"} className="mx-1" onClick={() => setSelectedData(item)} />
                                                                    {/* <CustomButton variant="dangerButton" text="Delete" className="mx-1" onClick={() => { setSelectedData(item), setShowModal(true) }} /> */}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </CustomTable>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <FormModal
                        title={`${isEdit ? "Edit" : "Add"} Service`}
                        open={formOpen}
                        toggle={onToggle}
                        onSubmit={onSubmit}
                        inputs={[
                            {
                                id: "title", label: "Title", placeholder: "Enter Title", required: true, initialValue: isEdit ? selectedData?.title : ""
                            },
                            {
                                id: "subtitle", label: "Subtitle", placeholder: "Enter Sub Title", required: true, initialValue: isEdit ? selectedData?.subtitle : ""
                            },
                            {
                                id: "image", label: "Icon", required: true, type: "image"
                            },
                        ]}
                    />
                    <CustomModal loading={isUpdating} show={selectedData} close={() => setSelectedData(null)} action={onConfirm} heading={`Are you sure you want to ${selectedData?.active ? "blacklist" : "active"} this service?`} />
                    <CustomModal show={confirmed} close={() => { toggleConfirmed() }} success heading={`Service has been ${!updatedService?.data?.active ? "Suspended" : "Activated"}`} />
                    {/* <CustomModal loading={isDeleting} show={showModal} close={() => { setShowModal(false) }} action={onDelete} heading='Are you sure you want to delete this guideline?' />
                    <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading={deletedData?.message} /> */}
                </div >
            </DashboardLayout >
        </>
    );
};

export default Services